import { render, staticRenderFns } from "./reset-pw.vue?vue&type=template&id=44ad901c&scoped=true&lang=pug"
import script from "./reset-pw.vue?vue&type=script&lang=js"
export * from "./reset-pw.vue?vue&type=script&lang=js"
import style0 from "../access.scss?vue&type=style&index=0&id=44ad901c&prod&lang=scss&scoped=true&external"
import style1 from "./reset-pw.vue?vue&type=style&index=1&id=44ad901c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ad901c",
  null
  
)

export default component.exports